import axios from 'axios';

// Dtos
interface SliderContentDto {
  heading: string;
  items: SliderContentItemDto[];
}

export interface SliderContentItemDto {
  title: string;
  subTitle: string;
  imageUrl: string;
  linkUrl: string;
}

// Map to models
function mapSliderContentDtoToModel(dto: SliderContentDto): SliderContentModel {
  return {
    heading: dto.heading,
    items: dto.items?.map(mapSliderContentItemDtoToModel) ?? [],
  };
}

function mapSliderContentItemDtoToModel(
  dto: SliderContentItemDto,
): SliderContentItem {
  return {
    title: dto.title,
    subTitle: dto.subTitle,
    imageUrl: dto.imageUrl,
    linkUrl: dto.linkUrl,
  };
}

// Models

interface SliderContentModel {
  heading: string;
  items: SliderContentItem[];
}

export interface SliderContentItem {
  title: string;
  subTitle: string;
  imageUrl: string;
  linkUrl: string;
}

// Fetch data
export const getSliderContent = async (
  startPageId: string,
  contentId: string,
  locale: string,
): Promise<SliderContentModel> => {
  const url = `/api/ContentData/GetSliderContent?startPageId=${startPageId}&contentId=${contentId}&locale=${locale}`;
  const response = await axios.get<SliderContentDto>(url);
  return mapSliderContentDtoToModel(response.data);
};
